import React from 'react';

import { useReactiveVar } from '@apollo/client/react';
import { IconButton } from '@mui/material';
import { AlineTooltip, workflowStepsDialogOpenVar } from 'src/components';
import { WorkflowIcon } from 'src/components/icons/WorkflowIcon';
import { useOnClickWorkflowButton } from 'src/editor/toolbars/editor-app-bars/components/WorkflowToolbarButton';
import { useCheckWorkflowAuthorization, useGetCurrentDoc } from 'src/hooks';

interface WorkflowButtonProps {
  disabled?: boolean;
}

export function WorkflowButton({ disabled }: WorkflowButtonProps): JSX.Element | null {
  const { document } = useGetCurrentDoc();
  const { onClickWorkflowButton } = useOnClickWorkflowButton();
  const { canViewWorkflow } = useCheckWorkflowAuthorization(document?.workflow?.id ?? null);

  const workflowOpen = useReactiveVar(workflowStepsDialogOpenVar);

  if (!document?.workflow || !canViewWorkflow) return null;

  return (
    <AlineTooltip
      arrow
      placement="bottom"
      title={workflowOpen ? 'Close workflow' : 'Open workflow'}
    >
      <div>
        <IconButton disabled={disabled} size="small" onClick={onClickWorkflowButton}>
          <WorkflowIcon />
        </IconButton>
      </div>
    </AlineTooltip>
  );
}
